import { Component, OnInit } from '@angular/core';
import { RawResultBatchDataService } from '../../data-services/rawResultBatch.service';
import { LazyLoadEvent } from 'primeng/api';
import { SelectItem, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { HasClaimDirective } from '../../security/has-claim.directive';

@Component({
  selector: 'app-result-list',
  templateUrl: './rawBatchResult.list.html',
  providers: [DialogService, MessageService, ConfirmationService, HasClaimDirective],
  animations: [
    trigger(
      'inOutAnimation',
      [
        transition(
          ':enter',
          [
            style({ height: 0, opacity: 0.5 }),
            animate('0.5s ease-out',
              style({ height: '*', opacity: 1 }))
          ]
        ),
        transition(
          ':leave',
          [
            style({ height: '*', opacity: 1 }),
            animate('0.5s ease-in',
              style({ height: 0, opacity: 0.5 }))
          ]
        )
      ]
    )
  ],
  imports: [ConfirmDialog, Toast, CommonModule, TableModule]
})
export class RawBatchResultListComponent implements OnInit {

  barcode = "";
  barcodeReading = false;

  constructor(private rawResultBatchDataService: RawResultBatchDataService,
    public dialogService: DialogService,
    private confirmationService: ConfirmationService  ) {
  }

  batches;
  statuses: SelectItem[] = [];
  facilities: SelectItem[] = [];
  testNames: SelectItem[] = [];
  totalRecords: number;
  cols: any[];
  includeExceptionsValue: any;
  includeExceptionsLabel: any = "No Exceptions Filter";
  includeRejectionsValue: any;
  includeRejectionsLabel: any = "No Rejects Filter";
  includeDateFilterValue: any;
  includeDateFilterLabel: any = "No Date Filter";
  loading: boolean;
  showSpinner: boolean = false;
  processingExceptions: boolean = false;
  selectedStatus: SelectItem;
  filter: any = {};
  filterDisplay: string = "None";
  queryParams: string;
  sub: any;

  ngOnInit() {


    this.cols = [
      { field: 'FileName', header: 'File Name', sortable: true, width: '21%' },
      { field: 'CreatedDate', header: 'Created', sortable: true, width: '15%' },
      { field: 'LabTestLIMSCode', header: 'File Type', sortable: true, width: '8%' },
      { field: 'SampleCount', header: 'Tests', sortable: true, width: '8%' },
      { field: 'ReportedCount', header: 'Reported', sortable: true, width: '8%' },
      { field: 'PositiveCount', header: 'Positive', sortable: true, width: '8%' },
      { field: 'NegativeCount', header: 'Negative', sortable: true, width: '8%' },
      { field: 'NeedReviewCount', header: 'Needs Review', sortable: true, width: '8%' },
      { field: 'QNSCount', header: 'QNS', sortable: true, width: '8%' },
      { field: 'RepeatCount', header: 'Repeat', sortable: true, width: '8%' }
    ];
    this.loading = true;
  }

  searchTerm: string = "";
  public handleSearchKey(event, reqlist) {
    if (event.keyCode == 13) {
      reqlist.filterGlobal(event.target.value, 'contains');
      this.searchTerm = event.target.value;
      this.filterDisplay = this.searchTerm;
      event.preventDefault();
    }
  }

  lastLoad: LazyLoadEvent;
  public loadBatchesLazy(event: LazyLoadEvent) {
    this.loading = true;
    if (event) {
      this.lastLoad = event;
    } else {
      this.lastLoad.first = 0;
      event = this.lastLoad;
    }
    this.rawResultBatchDataService.getList(event.first, event.rows, event.sortField, event.sortOrder, event.filters).subscribe((data: any) => {
      this.totalRecords = data.totalRows;
      this.batches = data.rows;

      if (this.batches.length == 1) {
        this.batches[0].showDetail = true;
      }
      else {
        for (var i = 0; i < this.batches.length; i++) {
          this.batches[i].showDetail = false;
        }
      }
      event.filters.global = {};
      this.loading = false;
    });
  }

  statusChanged(changedItem: any) {
    var batchToUpdate = this.batches.find(x => x.Id === +changedItem);
    this.rawResultBatchDataService.getBatchById(+changedItem).subscribe((data: any) => {

      const index = this.batches.findIndex(x => x.Id === +changedItem);
      data.showDetail = !data.Completed;
      this.batches[index] = data;
    });
  }

  public useFluLayout(limsCode: string): boolean {
    if (limsCode == "TMO-FLUVID" ||
      limsCode == "IDT-FLUVID" ||
      limsCode == "20501" ||
      limsCode == "20502" ||
      limsCode == "20511" ||
      limsCode == "20512" ||
      limsCode == "20521" ||
      limsCode == "20522" ||
      limsCode == "20205") {
      return true;
    }

    return false;
  }

  public deleteBatch(batchId) {
    this.confirmationService.confirm({
      message: "Are you sure that you want to delete this batch?",
      header: "Delete Batch",
      acceptLabel: 'Yes',
      rejectVisible: true,
      accept: () => {
        this.rawResultBatchDataService.deleteBatch(batchId).subscribe(() => {
          this.loadBatchesLazy(this.lastLoad);
        });
      }
    });
  }
}
